import { useParams } from "react-router-dom"

import { AgentDetailModule } from "@/features/agents/components/agent-detail-module"
import { AgentsModule } from "@/features/agents/components/agents-module"

/**
 * Single page component for every agents-module path. `/agents` renders the
 * roster; `/agents/:agentSlug` and `/agents/chat/:sessionId` render the
 * detail view (thread rail + chat). One shared component (and one shared
 * route element — see `buildAgentsDetailRouteObjects`) means React never
 * remounts the module while navigating between these paths, which keeps an
 * in-flight streamed answer alive across the create-on-send redirect.
 */
export function AgentsPage() {
  const { agentSlug, sessionId } = useParams<{ agentSlug?: string; sessionId?: string }>()

  if (agentSlug || sessionId) {
    return <AgentDetailModule />
  }
  return <AgentsModule />
}
